import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ContactService } from '../../model/shared-entities/contacts/contact.service';
import { NotificationsService } from '@mt-ng2/notifications-module';

@Injectable()
export class CustomerContactService extends ContactService {
    constructor(public http: HttpClient, notificationService: NotificationsService) {
        super('/customers', http, notificationService);
    }

}
